
import { message } from 'antd';
import { find } from 'lodash';
import { addAndUpdateTestCapability, getTestCapability, deleteTestCapability } from '../services/supplierApi';

function init() {
  return {
    data: [],
    record: {},
    visiable: false
  };
}

export default {
  namespace: 'testAbility',
  state: init(),
  effects: {
    *getData(_, { call, put }) {
      const res = yield call(getTestCapability);
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            data: {
              data: res.data
            }
          }
        });
      } else {
        res.msg && message.error(res.msg);
      }
    },
    *showEditModal({ payload: { data: { serialNumberT } } }, { put, select }) {
      const data = yield select(state => state.testAbility.data);
      const record = find(data, { serialNumberT });
      yield put({
        type: 'updateState',
        payload: {
          data: {
            record,
            visible: true
          }
        }
      });
    },
    *addAndUpdate({ payload: { data } }, { call, put }) {
      const result = yield call(addAndUpdateTestCapability, data);
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'updateState',
          payload: {
            data: {
              visible: false
            }
          }
        });
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *delete({ payload: { serialNumberT } }, { call, put }) {
      const result = yield call(deleteTestCapability, { serialNumber: serialNumberT });
      if (result.success) {
        message.success('操作成功');
        yield put({
          type: 'getData'
        });
      } else {
        result.msg && message.error(result.msg);
      }
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    clear() {
      return init();
    }
  }
};

